import theme from 'CommonStyle/themeJSX';
import styled from 'styled-components';

export const InputError = styled.p`
  font-size: 14px;
  line-height: calc(18 / 14);
  color: ${theme.colors.secondaryRed};
`;
